/**
 * Chinese translations. Missing keys fall back to the English source string,
 * so a partial dictionary never produces empty labels.
 */
export const zh: Record<string, string> = {
  Home: "首页",
  Explore: "发现",
  "Explore Relays": "发现中继",
  Notifications: "通知",
  Bookmarks: "收藏",
  Search: "搜索",
  Settings: "设置",
  Relays: "中继",
  "Relay feeds": "中继信息流",
  "Relay Feeds": "中继信息流",
  "Following": "关注",
  "Following feed": "关注信息流",
  Feed: "信息流",
  "Relay sets": "中继分组",
  "Relay set": "中继分组",
  "My relays": "我的中继",
  "Add relay": "添加中继",
  "Add to relays": "添加到中继",
  "Remove relay": "移除中继",
  "Remove from relays": "从我的中继移除",
  "New relay set": "新建中继分组",
  "Relay details": "中继详情",
  "Relay reviews": "中继评价",
  "Write a review": "撰写评价",
  "Publish review": "发布评价",
  "Supported NIPs": "支持的 NIP",
  Software: "软件",
  Description: "描述",
  "No description": "没有描述",
  "No NIP-11 metadata": "没有 NIP-11 元数据",
  "Search this relay": "搜索此中继",
  "This relay supports NIP-50 search": "此中继支持 NIP-50 搜索",
  Theme: "主题",
  Appearance: "外观",
  Light: "浅色",
  Dark: "深色",
  "Pure black": "纯黑",
  System: "跟随系统",
  Language: "语言",
  Account: "账户",
  Login: "登录",
  Logout: "退出登录",
  "Log in": "登录",
  "Log in with extension": "使用浏览器扩展登录",
  "Read only": "只读",
  "Public key": "公钥",
  "Private key": "私钥",
  "Publish a note": "发布笔记",
  Publish: "发布",
  Publishing: "发布中…",
  Reply: "回复",
  React: "点赞",
  Repost: "转发",
  Bookmark: "收藏",
  "Copy link": "复制链接",
  "Copy note id": "复制笔记 ID",
  "Copy relay address": "复制中继地址",
  "Load more": "加载更多",
  "New notes": "新笔记",
  "No notes yet": "还没有笔记",
  "No relays yet": "还没有中继",
  "No results": "没有结果",
  "Something went wrong": "出错了",
  "Try again": "重试",
  "Go back": "返回",
  "Back home": "返回首页",
  "Page not found": "页面不存在",
  "Get started": "开始使用",
  "Welcome": "欢迎",
  "Your relays": "你的中继",
  "Add relays to get started": "添加中继以开始使用",
  "Add your first relay": "添加你的第一个中继",
  "Read-only session": "只读会话",
  "Following's favorites": "关注的人收藏的中继",
  Recommended: "推荐",
  Discover: "发现",
  "Trending notes": "热门笔记",
  "Trending notes are fetched from the trending relay": "热门笔记来自热门中继",
  "Search relays": "搜索中继",
  "Local filter": "本地筛选",
  "Relay search": "中继搜索",
  "Search notes and people": "搜索笔记和用户",
  "Notes": "笔记",
  People: "用户",
  Profiles: "用户",
  "Relay feed": "中继信息流",
  "Feed type": "信息流类型",
  "Switch feed": "切换信息流",
  "Personal feeds": "个人信息流",
  "Choose a feed": "选择信息流",
  "Relay feeds are read from these relays": "中继信息流从这些中继读取",
  "connections": "连接",
  Connected: "已连接",
  Connecting: "连接中…",
  Reconnecting: "重连中…",
  Disconnected: "已断开",
  Unreachable: "无法连接",
  "Read": "读取",
  "Write": "写入",
  "Read & write": "读写",
  "Muted words": "屏蔽词",
  "Include replies in the feed": "在信息流中包含回复",
  "Live updates": "实时更新",
  "Reset settings": "重置设置",
  "Reset": "重置",
  "Save": "保存",
  "Cancel": "取消",
  "Delete": "删除",
  "Rename": "重命名",
  "Create": "创建",
  "Close": "关闭",
  "Loading…": "加载中…",
  "Loading relays…": "正在连接中继…",
  "Fetching relay information…": "正在获取中继信息…",
  "Review": "评价",
  "Stars": "评分",
  "Read from this relay": "从此中继读取",
  "Add to feed": "添加到信息流",
  "Streaming": "读取此中继",
  Follow: "关注",
  Following2: "已关注",
  Unfollow: "取消关注",
  "Followers": "关注者",
  "Follows you": "关注了你",
  "joined": "加入于",
  "No metadata": "没有资料",
  "Edit profile": "编辑资料",
  "Open relay": "打开中继",
  "Open profile": "打开用户",
  Profile: "个人主页",
  "Your profile": "你的主页",
  Muted: "已静音",
  Replies: "回复",
  Articles: "文章",
  Reposts: "转发",
  "All types": "全部类型",
  "Filter posts by type": "按类型筛选帖子",
  "Show all types": "显示全部类型",
  "No posts of this type": "没有该类型的帖子",
  "No bookmarks of this type": "没有该类型的书签",
  "This feed has no posts of the selected type. Pick another type or show all types.":
    "此信息流没有所选类型的帖子。请选择其他类型或显示全部类型。",
  "No post of the selected type matched. Pick another type or show all types.":
    "没有匹配所选类型的帖子。请选择其他类型或显示全部类型。",
  "Saved posts of other types are hidden by this filter.": "其他类型的已保存帖子被此筛选隐藏。",
  "Copy npub": "复制 npub",
  "Display name": "昵称",
  Name: "名称",
  About: "简介",
  "Avatar URL": "头像链接",
  "Banner URL": "横幅链接",
  "Lightning address": "闪电地址",
  Website: "网站",
  Reload: "重新加载",
  "No notes found": "没有找到笔记",
  "Profile saved": "资料已保存",
  "Published as a kind 0 metadata event to your relays.": "以 kind 0 元数据事件发布到你的中继。",
  "Filter this profile's notes": "筛选此用户的笔记",
  "with media": "含媒体",
  "articles": "文章",
  "New Note": "新笔记",
  Drafts: "草稿",
  "Saved drafts": "已保存的草稿",
  "Delete draft": "删除草稿",
  "No drafts yet — notes you close without posting are saved here.": "还没有草稿——关闭但未发布的笔记会保存在这里。",
  "Composer mode": "编辑模式",
  Edit: "编辑",
  Preview: "预览",
  "Write a note": "写一条笔记",
  "Next note in the thread…": "话题串中的下一条笔记…",
  "Thread note": "话题串笔记",
  "Remove note": "移除笔记",
  "Nothing to preview yet — write your note first.": "暂无可预览的内容——请先写下笔记。",
  Thread: "话题串",
  notes: "条笔记",
  Protected: "受保护",
  "Publish as a NIP-70 protected note": "以 NIP-70 受保护笔记发布",
  "What is a protected note?": "什么是受保护笔记？",
  "Choose which relays receive this note": "选择接收此笔记的中继",
  "Publish to relays": "发布到中继",
  "Optimal relays": "最佳中继",
  "1 relay": "1 个中继",
  relays: "个中继",
  "Pick relays": "选择中继",
  "Add a relay first.": "请先添加一个中继。",
  "Content warning": "内容警告",
  "e.g. spoilers": "例如：剧透",
  "Protected note (NIP-70)": "受保护笔记（NIP-70）",
  "Publish to optimal relays": "发布到最佳中继",
  "Add media": "添加媒体",
  "Media URL": "媒体链接",
  Insert: "插入",
  "Choose file…": "选择文件…",
  "Add emoji": "添加表情",
  Emoji: "表情",
  "Add a note to the thread": "在话题串中新增笔记",
  "Insert a bulleted list": "插入项目符号列表",
  "first point": "第一点",
  "second point": "第二点",
  "Post settings": "发布设置",
  Mentions: "提及",
  "Search people you follow": "搜索你关注的人",
  "Follow people to mention them here.": "关注一些人后即可在此提及。",
  Post: "发布",
  "Posting…": "发布中…",
  "Media uploads are not configured in this build — paste a hosted image, video or audio URL instead.":
    "此版本未配置媒体上传——请粘贴图片、视频或音频的链接。",
  'Protected notes carry a NIP-70 "-" tag. Relays must only share them with you and the accounts you mention, and require NIP-42 authentication before serving them.':
    "受保护笔记带有 NIP-70 的 “-” 标签：中继只能与你以及你提及的账户分享，并在提供该笔记前要求 NIP-42 认证。",
  // Unified filter system
  "Filters": "筛选",
  "Filter posts": "筛选帖子",
  "Active filters": "已启用的筛选",
  "Clear all": "全部清除",
  "Apply": "应用",
  "Apply ({n} active)": "应用（{n} 项）",
  "Narrow this list by content, time, engagement, people and relays.":
    "按内容、时间、互动、用户和中继缩小此列表。",
  "Content": "内容",
  "Post type": "帖子类型",
  "Media type": "媒体类型",
  "Text only": "仅文本",
  "Images": "图片",
  "Videos": "视频",
  "Audio": "音频",
  "Links": "链接",
  "With media": "含媒体",
  "Posts with several media types match every selected type.": "包含多种媒体的帖子会匹配任一已选类型。",
  "All languages": "所有语言",
  "Detected language only": "仅已识别语言",
  "Posts with no detectable language are kept when a language is selected.":
    "选择语言后，无法识别语言的帖子仍会保留。",
  "Hide posts containing muted words": "隐藏包含屏蔽词的帖子",
  "{n} words configured": "已配置 {n} 个屏蔽词",
  "Time & engagement": "时间与互动",
  "Time range": "时间范围",
  "All time": "全部时间",
  "Last hour": "最近 1 小时",
  "Last 24 hours": "最近 24 小时",
  "Last 7 days": "最近 7 天",
  "Last 30 days": "最近 30 天",
  "Custom range": "自定义范围",
  "Custom date range": "自定义日期范围",
  "From": "开始",
  "To": "结束",
  "Minimum likes": "最少点赞",
  "Minimum reposts": "最少转发",
  "Minimum replies": "最少回复",
  "Minimum total engagement": "最少总互动",
  "Sort by": "排序方式",
  "Latest": "最新",
  "Oldest": "最早",
  "Most liked": "点赞最多",
  "Most reposted": "转发最多",
  "Most discussed": "讨论最多",
  "Most engaged": "互动最多",
  "People & sources": "用户与来源",
  "Author filter mode": "作者筛选方式",
  "Only these authors": "仅这些作者",
  "Hide these authors": "隐藏这些作者",
  "Authors": "作者",
  "Search people": "搜索用户",
  "Search by name, username, npub or public key.": "按昵称、用户名、npub 或公钥搜索。",
  "From your follow list": "从你的关注列表",
  "Following status": "关注状态",
  "Everyone": "所有人",
  "Following only": "仅关注的人",
  "Non-following users": "未关注的用户",
  "Sources": "来源",
  "Only these relays are queried for this list.": "仅查询这些中继。",
  "Use this public key": "使用此公钥",
  "No cached profile matches. Paste an npub or public key.": "没有匹配的已缓存资料。请粘贴 npub 或公钥。",
  "{n} posts hidden by the active filters": "{n} 条帖子被当前筛选隐藏",
  "No posts match the filters": "没有匹配筛选的帖子",
  "This feed has no posts matching the selected filters. Relax a filter or clear them all.":
    "此信息流没有匹配所选筛选的帖子。请放宽条件或全部清除。",
  "No bookmarks match the filters": "没有匹配筛选的书签",
  "Saved posts that do not match the active filters are hidden.": "不符合当前筛选的已保存帖子被隐藏。",
  "{n} saved posts are hidden by the active filters": "{n} 条已保存帖子被当前筛选隐藏",
  "No post matched the selected filters. Relax a filter or clear them all.":
    "没有匹配所选筛选的帖子。请放宽条件或全部清除。",
  "This relay has no posts matching the selected filters. Relax a filter or clear them all.":
    "此中继没有匹配所选筛选的帖子。请放宽条件或全部清除。",
  "The trending relay has no posts matching the selected filters.": "热门中继没有匹配所选筛选的帖子。",
  "Interaction counts come from the events the connected relays delivered, so they can be lower than the real totals.":
    "互动计数来自已连接中继送达的事件，因此可能低于真实总数。",
  // Topic filtering
  "Topics": "话题",
  "Topic filter mode": "话题筛选方式",
  "Only these topics": "仅这些话题",
  "Hide these topics": "隐藏这些话题",
  "Clear topics": "清除话题",
  "Search topics": "搜索话题",
  "Selected topics": "已选话题",
  "Remove topic: {topic}": "移除话题：{topic}",
  "All topics": "全部话题",
  "No topic matches that search.": "没有匹配的话题。",
  "{n} topics match": "匹配 {n} 个话题",
  "Topic: {topic}": "话题：{topic}",
  "Hidden topic: {topic}": "隐藏话题：{topic}",
  "Posts detected as any of these topics are hidden. Uncategorized posts stay visible.":
    "被识别为这些话题的帖子将被隐藏；未分类的帖子仍然显示。",
  "Topics come from hashtags, title and text. Uncategorized posts are never hidden by a topic selection.":
    "话题来自标签、标题和正文；选择话题不会隐藏未分类的帖子。",
  Sports: "体育",
  Politics: "政治",
  Art: "艺术",
  Technology: "科技",
  Business: "商业",
  Education: "教育",
  Health: "健康",
  Music: "音乐",
  Entertainment: "娱乐",
  Science: "科学",
  "World News": "世界新闻",
  Gaming: "游戏",
  Food: "美食",
  Travel: "旅行",
  Environment: "环境",
  Finance: "金融",
  Lifestyle: "生活方式",
  Fashion: "时尚",
  History: "历史",
  Religion: "宗教",
  Cryptocurrency: "加密货币",
  Programming: "编程",
  Design: "设计",
  Photography: "摄影",
  "Movies & TV": "影视",
  Literature: "文学",
  Relationships: "情感关系",
  "Personal Development": "个人成长",
  Other: "其他",
}


